import actions from './actions';
import initialState from '../initialState';

export const appReducer = (state = initialState.app, action) => {
    switch (action.type) {
        case actions.SET_APP_LOADING:
            return { ...state, loading: { ...action.loading } };
        case actions.SET_APP_ERROR:
            return { ...state, error: { ...action.error } };
        case actions.SET_APP_ACTION:
            return { ...state, action: { ...action.action } };

        default:
            return { ...state };
    }
};

export default appReducer;
